import { useMemo } from "react";
import Text from "../Text";
import styles from "./HealthBar.module.css";

const HealthBar = ({
  value,
  min = 0,
  max = min + 10 * 24 * 60 * 60 * 1000,
}: {
  value: number;
  min?: number;
  max?: number;
}) => {
  const duration = max - value;
  const maxBarValue = 10 * 24 * 60 * 60 * 1000;

  const percentage = useMemo(() => {
    if (duration > maxBarValue) return 100;
    if (duration < 0) return 0;
    return (duration / maxBarValue) * 100;
  }, [duration, maxBarValue]);

  const isFlashing = useMemo(() => {
    return percentage <= 20;
  }, [percentage]);

  return (
    <div className={styles.component}>
      {percentage !== 0 ? (
        <div
          className={`${styles.bar} ${isFlashing ? styles.flashing : ""}`}
          style={{ width: `${percentage}%` }}
        />
      ) : (
        <Text
          variant="Body2"
          color="Red"
          style={{ bottom: 7, position: "relative" }}
        >
          EXPIRED
        </Text>
      )}
    </div>
  );
};

export default HealthBar;
